import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { PortfolioListComponent } from './list/list.component';
import { AuthGuard } from '../auth/auth.guard';
import { PortfolioService } from './portfolio.service';
import { SharedModule } from '../shared/shared.module';
import { PortfolioCreateComponent } from './create/create.component';
import { PortfolioFormComponent } from './form/form.component';
import { PortfolioEditComponent } from './edit/edit.component';

const routes: Routes = [
  {
    path: 'portfolios',
    component: PortfolioListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'portfolios/create',
    component: PortfolioCreateComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'portfolios/:id/edit',
    component: PortfolioEditComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  declarations: [
    PortfolioListComponent,
    PortfolioCreateComponent,
    PortfolioFormComponent,
    PortfolioEditComponent,
  ],
  imports: [
    BrowserModule,
    RouterModule,
    FormsModule,
    HttpClientModule,
    SharedModule,
    RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }),
  ],
  exports: [RouterModule],
  providers: [AuthGuard, PortfolioService],
})
export class PortfolioRoutingModule {}
